interface AdoptArgs {
  /** 부모(URL)가 지금 들고 있는 값. */
  value: string;
  /** 직전 렌더에서 본 부모 값. 실제로 바뀌었는지 판정한다. */
  lastSeen: string;
  /** 우리가 마지막으로 부모에게 올린 값. */
  pushed: string;
}

/**
 * 부모가 준 값을 입력창에 반영할지.
 *
 * 두 조건이 **각각 다른 사고를 막는다.** 하나라도 빼면 증상이 다르게 나타난다.
 *
 * 1. `value !== lastSeen` — 부모 값이 실제로 바뀌었을 때만. 이게 없으면 다른
 *    이유(부문 칩, 개정판 변경)로 리렌더될 때마다 입력창을 덮어쓴다.
 * 2. `value !== pushed` — 우리가 올린 값이 그대로 돌아온 **메아리**는 무시.
 *    이게 없으면 debounce 가 끝나 URL 이 갱신될 때마다 커서가 끝으로 튄다.
 *
 * 반영해야 하는 진짜 경우는 **밖에서 바뀐 값**뿐이다 — 뒤로가기, `?q=` 딥링크.
 *
 * ── 조합(IME) 중 여부를 왜 안 보나 ──────────────────────────
 * 여기서 `composing` 을 따로 막을 필요가 없다. `q` 를 쓰는 곳은 이 입력창뿐이고,
 * 올리는 타이머가 조합 중이면 건너뛰므로 **조합 중에는 `value` 가 바뀔 수 없다.**
 * 다른 조건(부문·개정판)이 바뀌어도 `q` 문자열은 그대로라 1번에서 걸린다.
 * (React Compiler 규칙상 ref 는 렌더 중에 읽을 수 없기도 하다.)
 */
export function shouldAdoptExternalValue({
  value,
  lastSeen,
  pushed,
}: AdoptArgs): boolean {
  if (value === lastSeen) return false;
  return value !== pushed;
}
